import React, { useState } from "react";
import BackButton from "../../../../../components/buttons/BackButton";
import ClassAcademicSettings from "./ClassAcademicSettings";
import UserCredentialsSettings from "./UserCredentialsSettings";
import PdfHeaderSettings from "./PdfHeaderSettings";

function SwitchSchoolSettings() {
  const [step, setStep] = useState(1);

  function switchTab() {
    switch (step) {
      case 1:
        return <ClassAcademicSettings />;
      case 2:
        return <UserCredentialsSettings />;
      case 3:
        return <PdfHeaderSettings />;

      default:
        return <ClassAcademicSettings />;
    }
  }

  return (
    <div className="p-8">
      <div className="p-4 text-right">
        <BackButton />
      </div>
      <div className="bg-white rounded-lg" style={{ display: "flex" }}>
        <div
          onClick={() => setStep(1)}
          style={{ flex: 1 }}
          className={`iskool-tab-item ${
            step === 1 ? "bg-gray-600 text-white shadow" : ""
          }`}
        >
          <div className="text-lg">Class Academic</div>
        </div>
        <div
          onClick={() => setStep(2)}
          style={{ flex: 1 }}
          className={`iskool-tab-item ${
            step === 2 ? "bg-gray-600 text-white shadow" : ""
          }`}
        >
          <div className="text-lg">Passwords</div>
        </div>
        <div
          onClick={() => setStep(3)}
          style={{ flex: 1 }}
          className={`iskool-tab-item ${
            step === 3 ? "bg-gray-600 text-white shadow" : ""
          }`}
        >
          <div className="text-lg">PDF Header</div>
        </div>
      </div>
      <div className="relative">
        <div>{switchTab()}</div>
      </div>
    </div>
  );
}

export default SwitchSchoolSettings;
